<template>
  <v-card flat class="mt-4 mb-4 default-settings-card">
    <v-card-text class="pa-4 pt-2">
      <b-row>
        <b-col :md="6">
          <b-form-group
            id="item-default-machine-group"
            label-for="default-machine-input"
          >
            <template v-slot:label>
              <span class="font-weight-bold">
                {{ $t("LABELS.DEFAULT_MACHINE") }}
              </span>
              <v-tooltip bottom max-width="400">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    class="ml-1"
                  >
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                <span>{{ $t("LABELS.DEFAULT_MACHINE_SERVICE_TOOLTIP") }}</span>
              </v-tooltip>
            </template>
            <v-autocomplete
              id="default-machine-input"
              :value="defaultMachine"
              :items="machines"
              item-text="name"
              return-object
              dense
              outlined
              clearable
              :placeholder="$t('LABELS.DEFAULT_MACHINE')"
              @input="$emit('update:defaultMachine', $event)"
            >
              <template v-slot:prepend-inner>
                <v-icon small color="grey">mdi-truck</v-icon>
              </template>
            </v-autocomplete>
          </b-form-group>
        </b-col>
        <b-col :md="6">
          <b-form-group
            id="item-default-warehouse-group"
            label-for="default-warehouse-input"
          >
            <template v-slot:label>
              <span class="font-weight-bold">
                {{ $t("LABELS.DEFAULT_WAREHOUSE_ITEM") }}
              </span>
              <v-tooltip bottom max-width="400">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    class="ml-1"
                  >
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                <span>{{ $t("LABELS.DEFAULT_WAREHOUSE_TOOLTIP") }}</span>
              </v-tooltip>
            </template>
            <v-autocomplete
              id="default-warehouse-input"
              :value="defaultWarehouseItem"
              :items="serviceWarehouseItems"
              item-text="name"
              item-value="id"
              dense
              outlined
              clearable
              :placeholder="$t('LABELS.DEFAULT_WAREHOUSE_ITEM')"
              @input="$emit('update:defaultWarehouseItem', $event)"
            >
              <template v-slot:prepend-inner>
                <v-icon small color="grey">mdi-package-variant</v-icon>
              </template>
            </v-autocomplete>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col :md="12">
          <v-alert
            dense
            text
            type="info"
            class="mb-0 mt-2"
            v-if="defaultMachine || defaultWarehouseItem"
          >
            <div class="d-flex align-items-center flex-wrap">
              <span>{{ $t("LABELS.DEFAULTS_ACTIVE") }}</span>
              <v-chip
                v-if="defaultMachine"
                small
                class="ml-2"
                color="primary"
                outlined
              >
                <v-icon x-small left>mdi-truck</v-icon>
                {{ defaultMachine.name }}
              </v-chip>
              <v-chip
                v-if="defaultWarehouseItem"
                small
                class="ml-2"
                color="success"
                outlined
              >
                <v-icon x-small left>mdi-package-variant</v-icon>
                {{ getWarehouseItemName(defaultWarehouseItem) }}
              </v-chip>
            </div>
          </v-alert>
        </b-col>
      </b-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ServiceInvoiceFormDefaultSettings",
  props: {
    defaultMachine: {
      type: Object,
      default: null
    },
    defaultWarehouseItem: {
      type: [Number, String],
      default: null
    },
    machines: {
      type: Array,
      default: () => []
    },
    serviceWarehouseItems: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getWarehouseItemName(id) {
      const item = this.serviceWarehouseItems.find(i => i.id === id);
      return item ? item.name : "";
    }
  }
};
</script>

<style scoped>
.default-settings-card {
  border: 2px solid #e3f2fd;
  background-color: #fafafa;
}

.default-settings-card .v-card__title {
  background: linear-gradient(90deg, #e3f2fd 0%, #ffffff 100%);
}
</style>
